import {
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { FundingSourceRepository } from '@/store/funding-source-state/funding-source-state.repository';
import { FundingSource } from '@/types';

interface getFundingSourceDataTableStructureProps {
  store: FundingSourceRepository;
  createAction?: () => void;
  rowActions?: any;
  serverQuery?: any;
}

export const getFundingSourceDataTableStructure = ({
  store,
  createAction,
  rowActions,
  serverQuery,
}: getFundingSourceDataTableStructureProps): DynamicDataTable => {
  const codeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'fundingSources.table.code',
    accessorKey: 'code',
    variant: DataTableColumnVariant.TEXT,
  };

  const descriptionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'fundingSources.table.description',
    accessorKey: 'description',
    variant: DataTableColumnVariant.TEXT,
  };

  const funderColumnIncludedColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'fundingSources.table.funder',
    accessorKey: 'bailleurDeFonds',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: string) => {
      return {
        value: value ? 'common.responses.yes' : 'common.responses.no',
        class: value ? 'bg-green-500' : 'bg-red-500',
      };
    },
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'fundingSources.table.createdAt',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'fundingSources.table.updatedAt',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  return {
    singular: 'fundingSources.singular',
    plural: 'fundingSources.plural',
    columns: [codeColumn, descriptionColumn, funderColumnIncludedColumn, createdAtColumn, updatedAtColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    createAction,
    target: (row: FundingSource) => {
      store.setNested('response', row);
      store.setNested('updateDto', {
        code: row.code,
        description: row.description,
        bailleurDeFonds: row.bailleurDeFonds,
      });
    },
    rowActions,
    searchableFields: [],
    enableServerActions: true,
    serverQuery,
  };
};
